import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo } from 'react';
import Header from '@dbh/header';
import CitiesTilesSection from '@dbh/cities-tiles-section';
import HTMLContentSection from '@dbh/html-content-section';
import { jsxs, Fragment } from 'react/jsx-runtime';

var _Fragment;const CityPage=/*#__PURE__*/memo(()=>_Fragment||(_Fragment=/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/_jsx(Header,{}),/*#__PURE__*/_jsx(CitiesTilesSection,{}),/*#__PURE__*/_jsx(HTMLContentSection,{})]})));CityPage.displayName="CityPage";

export { CityPage as default };
